import { __extends } from "tslib";
import { TfjsImageRecognitionBase } from 'tfjs-image-recognition-base';

var TinyFaceDetectorOptions =
/** @class */
function (_super) {
  __extends(TinyFaceDetectorOptions, _super);

  function TinyFaceDetectorOptions() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._name = 'TinyFaceDetectorOptions';
    return _this;
  }

  return TinyFaceDetectorOptions;
}(TfjsImageRecognitionBase.TinyYolov2Options);

export { TinyFaceDetectorOptions };